export default {
	'stores-are-being-brought-in': 'جاري جلب المتاجر ..'
}